import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
	legendHead: {
		background: '#303235',
		'&:hover': {
			background: '#303235',
		},
		marginTop: '0px',
		position: 'absolute',
		left: '0px',
		top: '0px',
		color: '#FFFFFF',
		width: '365px',
		textAlign: 'down',
		mixBlendMode: 'normal',
		boxShadow: '0px 8px 8px rgba(0, 0, 0, 0.25)',
		borderRadius: '0px',
		zIndex: '1',
	},
	LegendItemsDivParent: {
		width: '365px',
		height: 'auto',
		left: '0px',
		position: 'relative',
		top: '0px',
		background: '#303235',
		mixBlendMode: 'normal',
		boxShadow: '0px 8px 8px rgba(0, 0, 0, 0.25)',
		zIndex: '1',
		display: 'flex',
		flexDirection: 'column',
	},
	LegendItemsDiv: {
		width: '365px',
		height: '312px',
		left: '0px',
		position: 'relative',
		top: '61px',
		background: '#303235',
		mixBlendMode: 'normal',
		boxShadow: '0px 8px 8px rgba(0, 0, 0, 0.25)',
		zIndex: '1',
		display: 'flex',
	},
	IconImages: {
		width: '24px',
		height: '24px',
		marginLeft: '15px',
		marginRight: '5px',
		zIndex: '10',
	},
	IconTexts: {
		fontWeight: '400',
		fontSize: '17px',
		lineHeight: '25.5px',
		paddingLeft: '15px',
		paddingRight: '15px',
		color: 'rgba(255, 255, 255, 0.9)',
		textAlign: 'center',
		zIndex: '10',
	},
}));

export { useStyles };
